import { trigger, style, animate, transition, query, stagger } from '@angular/animations';

export const slideInOnlyUpStaggered = trigger('slideInOnlyUpStaggered', [
  transition('* => *', [
    // each time the binding value changes
    query(
      ':enter',
      [
        style({ transform: 'translateY(1000%)', opacity: 0 }),
        stagger(80, [animate('250ms ease-out', style({ transform: 'translateY(0)', opacity: 1 }))]),
      ],
      { optional: true }
    ),
  ]),
]);
